const getGlobal = () => globalThis || window;

export default getGlobal;
